import { useTranslation } from "react-i18next";
import { Radio, Stack, Text, List } from "@mantine/core";
import { RadioSurvey } from "../../../components";

type Props = {
  form: any;
};

const Component = ({ form }: Props) => {
  const { t } = useTranslation();

  const manifestacionesAcosoSexual = {
    AT_001AS:
      "Comentarios o bromas de contenido sexual o sexista (presenciales o digitales).",
    AT_002AS:
      "Comentarios o bromas sobre la orientación sexual o identidad de género.",
    AT_003AS:
      "Comentarios o gestos sobre la apariencia física que generan incomodidad.",
    AT_004AS:
      "Contacto a través de distintos canales por temas no laborales o invitaciones insistentes a salir.",
    AT_005AS:
      "Solicitar, enviar, alterar o difundir sin consentimiento material audiovisual de contenido sexual.",
    AT_006AS:
      "Contacto físico no deseado o inapropiado para el contexto laboral (rozar, masajear, besar, abrazar).",
    AT_007AS:
      "Insinuar, ofrecer beneficios o amenazar condiciones laborales a cambio de acercamientos, citas o favores de índole sexual.",
  };

  // Get selected manifestations from form
  const selectedManifestations = form.values.AT_001_007AS || [];
  // Filter manifestations that are selected and not "N.A"
  const displayedManifestations = selectedManifestations
    .filter(
      (key: string) =>
        key !== "N.A" &&
        manifestacionesAcosoSexual[
          key as keyof typeof manifestacionesAcosoSexual
        ]
    )
    .map(
      (key: string) =>
        manifestacionesAcosoSexual[
          key as keyof typeof manifestacionesAcosoSexual
        ]
    );

  return (
    <Stack spacing="md">
      {displayedManifestations.length > 0 && (
        <Stack spacing="xs">
          <Text size="sm" fw={500} color="gray.7">
            Sobre las siguientes situaciones:
          </Text>
          <List size="sm" spacing={4} withPadding>
            {displayedManifestations.map(
              (manifestacion: string, index: number) => (
                <List.Item key={index}>
                  <Text size="sm" color="gray.8">
                    {manifestacion}
                  </Text>
                </List.Item>
              )
            )}
          </List>
        </Stack>
      )}

      <RadioSurvey
        label="¿Con qué frecuencia se dieron estas situaciones?"
        {...form.getInputProps("FRE_001AS")}
      >
        <Radio
          label="Se trata de un evento puntual"
          value="Se trata de un evento puntual"
        />
        <Radio
          label="Varias veces a la semana"
          value="Varias veces a la semana"
        />
        <Radio label="Una vez al mes o menos" value="Una vez al mes o menos" />
        <Radio label="Varias veces al mes" value="Varias veces al mes" />
      </RadioSurvey>
    </Stack>
  );
};

export default Component;
